import { createSlice } from "@reduxjs/toolkit"
import usersApiSlice from "services/admin/usersApiSlice"

const initialState = {
  users: [],
}

const slice = createSlice({
  name: "users",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addMatcher(
      usersApiSlice.endpoints.fetchUsers.matchFulfilled,
      (state, action) => {
        state.users = action.payload
      },
    )
    builder.addMatcher(
      usersApiSlice.endpoints.fetchUsers.matchPending,
      (state, action) => {
        state.users = []
      },
    )
    builder.addMatcher(
      usersApiSlice.endpoints.addUser.matchFulfilled,
      (state, action) => {
        state.users.unshift(action.payload)
      },
    )

    builder.addMatcher(
      usersApiSlice.endpoints.updateUser.matchFulfilled,
      (state, action) => {
        const updatedUser = action.meta.arg.originalArgs
        const { _id } = updatedUser
        delete updatedUser["password"]
        const index = state.users.findIndex((user) => user?._id == _id)
        state.users[index] = updatedUser
      },
    )

    builder.addMatcher(
      usersApiSlice.endpoints.deleteUser.matchFulfilled,
      (state, action) => {
        const deletedUsers = action.payload.deletedUsers
        state.users = state.users.filter((user) => {
          return !deletedUsers.includes(user?._id)
        })
      },
    )
  },
})

export default slice.reducer

// export const {logout} = slice.actions
